export default __webpack_public_path__ + "media/flags/sd-979c7eab.svg";